import { queryOptions, useQuery, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { searchUsers, type UserSearchParams } from "./services";

export const userKeys = {
  all: ["users"] as const,
  search: (params: UserSearchParams) => [...userKeys.all, "search", params] as const,
};

export function userSearchOptions(params: UserSearchParams) {
  return queryOptions({
    queryKey: userKeys.search(params),
    queryFn: () => searchUsers(params),
    staleTime: 30_000,
  });
}

export function useSearchUsersQuery(params: UserSearchParams) {
  return useSuspenseQuery(userSearchOptions(params));
}

// Non-suspense version for components that don't need Suspense behavior
export function useSearchUsersQueryAsync(params: UserSearchParams) {
  return useQuery(userSearchOptions(params));
}

export function usePrefetchUsersQuery(params: UserSearchParams) {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.prefetchQuery(userSearchOptions(params));
  }, [queryClient, params.search, params.role, params.include, params]);
}
